import { useContext } from 'react';

import { WidgetAnimationContext } from '@/features/Dashboard/context/WidgetAnimation/context';

export const useWidgetAnimation = () => {
  const ctx = useContext(WidgetAnimationContext);
  if (!ctx) throw new Error('useWidgetAnimation must be used within WidgetAnimationProvider');
  return ctx;
};
